<script setup lang="ts">
import { useProductStore } from '~/store/product/productStore';
import { MODAL_MULTIPLE_PAYMENT, MODAL_OPEN, useModalStore } from '~/store/modalStore';

const productStore = useProductStore();
const modalStore = useModalStore();
const {
  product,
  offer,
} = storeToRefs(productStore);

const config = useRuntimeConfig();

const isKlarnaEligible = computed(() => {
  return offer.value.price.finalPrice >= parseInt(config.public.klarnaThreeMin as string) &&
      offer.value.price.finalPrice <= parseInt(config.public.klarnaThreeMax as string)
})
const isPaypalEligible = computed(() => {
  return offer.value.price.finalPrice >= parseInt(config.public.paypalFourMin as string) &&
      offer.value.price.finalPrice <= parseInt(config.public.paypalFourMax as string)
})

const klarnaIsActive = ref(parseInt(config.public.enableKlarna as string) === 1);
const paypalIsActive = ref(parseInt(config.public.enablePaypal as string) === 1);

const modal = () => modalStore.displayModal(MODAL_MULTIPLE_PAYMENT, MODAL_OPEN);
</script>

<template>
  <div class="center-text">
    <div
:class="`center-text size--footnote pointer weight--interregular ${isKlarnaEligible || isPaypalEligible ? ' ' : ' hidden'} }}`"
         style="line-height: 27px;"
         data-tclz-selector="payment-multiple"
         :data-tclz-label="product.categoryPath"
         data-tclz-category="product"
         @click="modal">
        <span class="pointer underline-text weight--intermedium mr-h pe-n">
                <span v-if="klarnaIsActive" :class="`${isKlarnaEligible ? '' : ' hidden'}`">3x</span>
                <span v-if="isKlarnaEligible && isPaypalEligible">&nbsp;{{ $t('www.product.reassurance.or') }}&nbsp;</span>
                <span
v-if="paypalIsActive"
                      :class="`pe-n ${isPaypalEligible ? '' : ' hidden' }`">4x</span>
            {{ $t('www.product.reassurance.free') }}</span>
    </div>
  </div>
</template>
